module.exports = __webpack_public_path__ + "static/media/virtual-events-5.f5af51d6.jpg";